export const clientUrl =
  process.env.GATSBY_CLIENT_URL || "https://app.extensionkit.io";

  export const staticUrl =
    process.env.GATSBY_STATIC_URL ||
    "https://extensionkit-static.s3.amazonaws.com";
